import { Button, Grid, Image, Text } from "@mantine/core";
import { Link, useNavigate, useParams } from "react-router-dom";
import { verifyEmail } from "../../services/auth";
import useStyles from "./style";
import TableLoader from "../../components/TableLoader";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { pageInfoAnalytics } from "../../config/mixpanelConfig";
import { setCookie } from "../../utils";
// import { jwtDecode } from "jwt-decode"; // ✅ This is actually correct
import { getProfile } from "../../services/profile";
import { getPackages } from "../../services/package";
import { selectSkyPointPlan } from "../../services/subscription";

const VerifyEmail = () => {
  const { emailVerifyLoading } = useSelector((state) => state.auth);
  const { classes } = useStyles();
  const navigate = useNavigate();
  const params = useParams();
  const [success, setSuccess] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [passwordToken, setPasswordToken] = useState("");
  const { profile } = useSelector((state) => state?.profile);

  useEffect(() => {
    getProfile();
    getPasswordSetLink();
    pageInfoAnalytics("Verify Email Page Viewed", "Verify Email Page");
  }, []);

  // useEffect(() => {
  //   if (params?.token) {
  //     setCookie(params?.token, "token");
  //     console.log("🚀 ~ VerifyEmail ~ params.token:", params.token);

  //     try {
  //       const decoded = jwtDecode(params.token);
  //       console.log("Decoded:", decoded);
  //     } catch (err) {
  //       console.error("Invalid token", err);
  //     }
  //   }
  // }, [params?.token]);

  // const getPasswordSetLink = async () => {
  //   let response = await verifyEmail({
  //     token: params?.token,
  //   });
  //   if (response?.data) {
  //     setShowPassword(!response?.data?.hasPassword);
  //     setPasswordToken(response?.data?.setPasswordToken);
  //     setSuccess(true);
  //   }
  // };

  const getPasswordSetLink = async () => {
    try {
      const response = await verifyEmail({
        token: params?.token,
      });

      if (response?.data) {
        setShowPassword(!response.data.hasPassword);
        setPasswordToken(response.data.setPasswordToken);
        setSuccess(true);
      }
    } catch (error) {
      console.error("Error verifying email:", error);
    }
  };

  const setPassword = () => {
    navigate(`/reset-password-skypoint/${passwordToken}`, {
      state: {
        title: "Set Your Password",
      },
    });
  };

  const [assigningPlan, setAssigningPlan] = useState(false);

  const continueToLogin = async () => {
    if (profile?.user?.type === "contractor") {
      setAssigningPlan(true);
      try {
        const data = await getPackages(profile?.user?.id);
        const freePackage = data?.packages
          ?.filter((pkg) => pkg.type === "skypoint" && Number(pkg.cost) === 0)
          ?.[0];
        if (freePackage) {
          await selectSkyPointPlan({ id: freePackage.id });
          await getProfile();
        }
      } catch (err) {
        console.error("Failed to assign free plan:", err);
      } finally {
        setAssigningPlan(false);
      }
      navigate("/home/dashboard-skypoint");
    } else {
      navigate("/skypoint-signup", { state: { token: params?.token } });
    }
  };


  return (
    <Grid className={classes.container}>
      <Grid.Col span={6} className={classes.left_pane}>
        <div className={classes.welcome}>
          <Link to={"/"}>
            <Image
              src="/assets/images/skypoint-logo2.png"
              mr={"auto"}
              fit="fill"
              className={classes.logo}
            />
          </Link>
        </div>
      </Grid.Col>
      <Grid.Col
        span={6}
        className={classes.right_pane}
        style={{ position: "relative" }}
      >
        <div
          style={{
            background: "white",
            height: "50%",
            borderRadius: "10px",
            width: "100%",
            position: "absolute",
            top: "30%",
            left: "-50%",
            border: "1px solid gray",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <center>
            {emailVerifyLoading ? (
              <>
                <Text className={classes.title}>Verifying Email</Text>
                <TableLoader />
              </>
            ) : success ? (
              <div>
                <div className="d-flex">
                  <Text className={classes.title}>Email Verified</Text>
                  <img
                    src="/assets/images/greenCheck.png"
                    width={50}
                    alt="green check mark"
                  />
                </div>
                {showPassword ? (
                  <Button
                    style={{
                      padding: "0 .5rem",
                      width: "max-content",
                      fontSize: "1rem",
                    }}
                    color="yellow"
                    className={classes.login_btn}
                    onClick={setPassword}
                  >
                    Set Your Password
                  </Button>
                ) : (
                  <Button
                    color="gray"
                    className={classes.login_btn}
                    onClick={continueToLogin}
                    loading={assigningPlan}
                    disabled={assigningPlan}
                  >
                    Continue
                  </Button>
                )}
              </div>
            ) : (
              <Text className={classes.title}>
                Your Invitation Link has been Expired!
              </Text>
            )}
          </center>
        </div>
      </Grid.Col>
    </Grid>
  );
};

export default VerifyEmail;
